import IReceiptVm from "./../shared/IReceiptVm"
import { ReceiptType } from "./../enums/ReceiptType"
import { SendStatusType } from "./../enums/SendStatusType"

import * as IReceiptVmInstance from "./../shared/IReceiptVm"

export default interface IFrendsReceiverRequestVm {
    id: string
    createdDate: string
    bat2FrendsOrderId: string
    frendsOrderId: string
    status: SendStatusType
    sentRequestAttempts: number
    maxSentRequestAttempts: number
    formKey: string
    formValue: string
    receiptType: ReceiptType
    latestError: string
    previousMunicipality: string
    caseWorker: string
    receipt: IReceiptVm
    driverLicenseFrontAttachmentBase64Image: string
    driverLicenseBackAttachmentBase64Image: string
    taxLicenseFrontAttachmentBase64Image: string
    taxLicenseBackAttachmentBase64Image: string
    educationalLicenseAttachmentBase64Image: string
    profileImageBase64Image: string
}

export const empty = (enableIteration: boolean = true): IFrendsReceiverRequestVm => {
	return {
		id: "",
		createdDate: "",
		bat2FrendsOrderId: "",
		frendsOrderId: "",
		status: SendStatusType.NotSet,
		sentRequestAttempts: -1,
		maxSentRequestAttempts: -1,
		formKey: "",
		formValue: "",
		receiptType: ReceiptType.NotSet,
		latestError: "",
		previousMunicipality: "",
		caseWorker: "",
		receipt: IReceiptVmInstance.empty(),
		driverLicenseFrontAttachmentBase64Image: "",
		driverLicenseBackAttachmentBase64Image: "",
		taxLicenseFrontAttachmentBase64Image: "",
		taxLicenseBackAttachmentBase64Image: "",
		educationalLicenseAttachmentBase64Image: "",
		profileImageBase64Image: ""
	} as IFrendsReceiverRequestVm
}